import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { AlertTriangle } from "lucide-react";

interface SameDayCancelDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SameDayCancelDialog = ({ isOpen, onClose, onConfirm }: SameDayCancelDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="rounded-lg sm:max-w-[425px]">
        <DialogHeader className="flex flex-col items-center gap-2">
          <Avatar className="h-12 w-12 bg-amber-100">
            <AvatarFallback className="bg-transparent">
              <AlertTriangle className="h-6 w-6 text-amber-600" />
            </AvatarFallback>
          </Avatar>
          <DialogTitle className="text-xl">Отмена день в день до 10:00</DialogTitle>
          <DialogDescription className="text-center">
            При отмене день в день вам начисляется 50% от стоимости занятия в виде бонусов, но
            занятие списывается.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4 flex gap-2 sm:gap-0">
          <Button variant="outline" className="flex-1 sm:flex-none" onClick={onClose}>
            Отмена
          </Button>
          <Button
            className="flex-1 bg-amber-600 hover:bg-amber-700 sm:flex-none"
            onClick={onConfirm}
          >
            Подтвердить
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SameDayCancelDialog;
